// Version 01.17.25

export default function (opts) {
  var options = {
    elements: [],
    offset: () => 0,
    onEnter: () => {}
  }

  var state = {
    scrollTop: 0,
    current: null
  }

  var setOptions = opts => { options = Object.assign({}, options, opts) }
  var setState = newState => { state = Object.assign({}, state, newState) }

  setOptions(opts)

  options.elements = options.elements.map((el, i) => {
    return {
      element: el,
      index: i
    }
  })

  function check () {
    var scrollTop = window.scrollY + options.offset()
    setState({ scrollTop })
    tops(options.elements)
  }

  function tops (elements) {
    var newElements = elements.slice()
    newElements.reverse()
    newElements.some(e => {
      if (state.scrollTop >= e.element.offsetTop) {
        if (state.current !== e.index) {
          setState({ current: e.index })
          options.onEnter(e.element)
        }
        return true
      }
    })
  }

  return {
    check
  }
}